import { useEffect } from 'react';

export function useJsonLd(data: object) {
  const serialized = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = serialized;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [serialized]);
}